<template>
	<div>
		<van-nav-bar title="成员管理" left-text="返回" fixed placeholder left-arrow @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-search v-model="kw" maxlength="10" placeholder="搜索" @search="onSearch" />
		<div style="margin-left: 0.2rem;color: #B6B6B6;font-size: 10px;">
			<p>管理员（可以执行特殊操作，如[<span style="color: red;"> @踢出 </span>/<span style="color: red;"> @加减金币 </span>]等等）</p>
			<p>小黑屋（黑名单 不允许此人进群）</p>
		</div>
		<van-list>
			<van-cell v-for="(item, index) in list" :key="index" center size="large">
				<template #icon>
					<div style="margin-right: 10px;">
						<img :src="item.headimgurl" style="width: 32px;height: 32px;border-radius: 100%;">
					</div>
				</template>
				<template #title>
					<div class="custom-title" style="font-size: 12px;" :style="{color: item.is_delete==1?'red':''}">{{item.nick}}</div>
				</template>
				<template #label>
					<div class="custom-title" style="font-size: 12px;" :style="{color: item.is_delete==1?'red':''}">最后发言：{{item.last_date}}</div>
					<div class="custom-title" style="font-size: 12px;" :style="{color: item.is_delete==1?'red':''}">连续签到：{{item.sign_num}}天</div>
				</template>
				<template #extra>
					<van-button :type="item.is_manage ? 'info' : 'default'" size="mini" @click="onOp( index, 'manage', $event )">管理员</van-button>
					<van-button :type="item.is_black ? 'info' : 'default'" size="mini" @click="onOp( index, 'black', $event )">小黑屋</van-button>
					<van-button v-if="item.is_delete==1" disabled type="danger" size="mini" @click="onOp( index, 'del', $event )">移除</van-button>
					<van-button v-else type="danger" size="mini" @click="onOp( index, 'del', $event )">移除</van-button>
				</template>
			</van-cell>
		</van-list>

	</div>


</template>

<script>
	import Vue from 'vue';
	import { Search } from 'vant';
	
	Vue.use(Search);
	export default {
		data() {
			return {
				group_id: 0,
				kw: '',
				list: []
			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.users({
				id: group_id
			}).then(res => {
				this.list = res.list
			})
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			onSearch(){
				this.$ApiUtil.GroupCenterSrc.users({
					id: this.group_id,
					kw: this.kw
				}).then(res => {
					this.list = res.list
				})
			},
			onOp(idx, op, event = null){
				var id = this.list[idx].id
				this.$ApiUtil.GroupCenterSrc.users({
					id: this.group_id,
					op_id: id,
					op: op
				}).then(res => {
					if(!res.status){
						this.$toast(res.message)
					}else{
						this.$toast('操作成功')
						if(op == 'del'){
							event.srcElement.className = event.srcElement.className + ' van-button--disabled'
							event.srcElement.disabled = true
						}
						if(op == 'black' || op == 'manage'){
							var class_name = '';
							if(event.srcElement.className.indexOf('default') > -1){
								class_name = 'van-button van-button--info van-button--mini'
							}else{
								class_name = 'van-button van-button--default van-button--mini'
							}
							event.srcElement.className = class_name
						}
					}
				})
			}
		}
	}
</script>
